import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'i18n';

const propTypes = {
  numberOfAdults: PropTypes.number.isRequired,
  numberOfChildren: PropTypes.number.isRequired,
};

function RoomOccupancyComponent({ numberOfAdults, numberOfChildren }) {
  return (
    <Fragment>
      <FormattedMessage
        id='selectRooms.component.numberOfAdults.label'
        description='format for plural: {number, number} {number, plural, one {adult} other {adults}'
        defaultMessage={`{number, number} {number, plural,
          one {adult}
          other {adults}
        }`}
        values={{ number: numberOfAdults }}
      />
      {numberOfChildren > 0 && (
        <Fragment>
          {','}&nbsp;&nbsp;
          <FormattedMessage
            id='selectRooms.component.numberOfChildren.label'
            description='format for plural: {number, number} {number, plural, one {child} other {children}'
            defaultMessage={`{number, number} {number, plural,
              one {child}
              other {children}
            }`}
            values={{ number: numberOfChildren }}
          />
        </Fragment>
      )}
    </Fragment>
  );
}

RoomOccupancyComponent.propTypes = propTypes;

export default RoomOccupancyComponent;
